type LerpArgs = {
  y1: number;
  y2: number;
  x: number;
  x1: number;
  x2: number;
};
export function lerp({ y1, y2, x, x1, x2 }: LerpArgs): number {
  return y1 + ((x - x1) * (y2 - y1)) / (x2 - x1);
}
